import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Status } from "lib/enums";
import { BulkApplyData } from "lib/types";
import { putBulkApply, BulkApplynUpdatePayload } from "./bulkApplyActions";
import { RootState } from "../../store";

type BulkApplyDataState = {
    data: { [projectId: number]: { [siteId: number]: { [siteDesignId: number]: BulkApplyData[] } } },
    statuses: { [projectId: number]: { [siteId: number]: Status } },
    bulkApplyStatus: Status
};

const initialState: BulkApplyDataState = {
    data: {},
    statuses: {},
    bulkApplyStatus: Status.Idle
};

const bulkApplySlice = createSlice({
    name: 'bulkApply',
    initialState: initialState,
    reducers: {},
    extraReducers: builder => builder
        .addCase(putBulkApply.pending, state => {
            state.bulkApplyStatus = Status.Pending;
        })
        .addCase(putBulkApply.fulfilled, (state, action: PayloadAction<BulkApplynUpdatePayload>) => {
            state.bulkApplyStatus = Status.Success;
        })
        .addCase(putBulkApply.rejected, (state, action) => {
            state.bulkApplyStatus = Status.Rejected;
        })
});

export const selectBulkApplyLoading = (state: RootState): boolean => Object.values(state.bulkApply.statuses).some(status => status === Status.Pending)


export default bulkApplySlice.reducer;